import React from "react";
import { useSelector } from "react-redux";
import s from "./style.scss?module";
import { isNoEditRoute } from "../../hooks/helpers";
import { webView } from "../../variables/webView";
function BuildPrealoader({ toggle }) {
  const { preloaderToggle } = useSelector((state) => ({
    preloaderToggle: state.preloader.toggle,
  }));

  if (preloaderToggle || toggle) {
    return (
      <div className={s.loaderWrapper}>
        {!isNoEditRoute && webView ? null : (
          <div className={s.loader}>
            <svg viewBox="0 0 80 80">
              <rect x="8" y="8" width="64" height="64"></rect>
            </svg>
          </div>
        )}
      </div>
    );
  } else {
    return <></>;
  }
}

export default BuildPrealoader;
